// extracted by mini-css-extract-plugin
export default {"profilePicContainer":"styles_profilePicContainer__O1W6X","title":"styles_title__IcmLP","guidelines":"styles_guidelines__i+90r"};